import { getCalculatedPeriod } from "../../../Utils/utils"
import { COMPARE_IDS, getAvailableCompareIds, getCompareRange } from "../CompareSelect/presets"

export const resolveCompare = (compare, nextPeriod) => {
  if (!compare?.mode || compare.mode === COMPARE_IDS.CUSTOM) return compare
  const calculated = getCalculatedPeriod(nextPeriod)
  const available = getAvailableCompareIds(calculated)
  const mode = available.includes(compare.mode) ? compare.mode : COMPARE_IDS.PREV_PERIOD

  return { mode, range: getCompareRange(calculated, mode) }
}
